document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.process-hover');

  sections.forEach(section => {
    const steps = section.querySelectorAll('.process-hover__step');
    const images = section.querySelectorAll('.process-hover__image');

    if (!steps.length || !images.length) return;

    steps.forEach((step, index) => {
      step.addEventListener('mouseenter', () => {
        // Clear all states
        steps.forEach(s => s.classList.remove('is-active'));
        images.forEach(img => img.classList.remove('is-active'));

        // Activate current step
        step.classList.add('is-active');

        if (images[index]) {
          images[index].classList.add('is-active');
        }

        // 🔑 Tell CSS that a step is active
        section.classList.add('has-active-step');
      });
    });

    // When leaving the whole component, reset to default image
    section.addEventListener('mouseleave', () => {
      steps.forEach(s => s.classList.remove('is-active'));
      images.forEach(img => img.classList.remove('is-active'));

      // 🔑 Restore default image
      section.classList.remove('has-active-step');
    });
  });
});